import { Component } from 'react'
import { withTranslation } from 'react-i18next'

/**
 * The wall between one broken thing and the whole portal.
 *
 * Three times now a single unexpected value — an undefined prop, a link without a scheme — has
 * unmounted React entirely: white screen, scroll locked, nothing to do but reload. Each value gets
 * fixed, and the next one will still find something. This is the guarantee the fixes cannot make:
 * whatever breaks inside stays inside, and the person sees a sentence and a way back instead of a
 * dead page.
 */
class Boundary extends Component {
  constructor(props) {
    super(props)
    this.state = { broken: false }
  }

  static getDerivedStateFromError() {
    return { broken: true }
  }

  componentDidCatch(error) {
    console.error('A view failed to render', error)
  }

  componentDidUpdate(previous) {
    // A new subject means a new chance: opening a different post must not show the last one's
    // failure. `resetOn` is whatever identifies the content — a post id, a route.
    if (this.state.broken && previous.resetOn !== this.props.resetOn) {
      this.setState({ broken: false })
    }
  }

  render() {
    if (!this.state.broken) return this.props.children

    const { t, onClose } = this.props

    return (
      <div className="broken">
        <p>{t('common.viewBroke')}</p>
        {onClose ? (
          <button type="button" className="button" onClick={onClose}>
            {t('common.close')}
          </button>
        ) : (
          <button type="button" className="button" onClick={() => window.location.reload()}>
            {t('common.reload')}
          </button>
        )}
      </div>
    )
  }
}

export default withTranslation()(Boundary)
